import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Image from 'react-bootstrap/Image';
import profile from "../assets/img/Profile1.JPG";
import "../css/styles.css"
import "../css/Montserrat.css"
import "../css/Roboto.css"
import "../js/scripts.js"
import "../css/Course.css"

const book1 =  "/profile/book1.png";
const book2 = "/profile/book2.png";
const arch1 = "/profile/lcpc.png";
const arch2 = "/profile/lego.png";
const arch3 = "/profile/icfnew.png";
const arch4 = "/profile/icfmembernew.png";

const AboutUs = () => {
  return (
    <Container className="my-5">
      <Row className="justify-content-md-center">
        <Col md={4} className="d-flex justify-content-center align-items-center">
          <Image src={profile} rounded style={{width:'100%'}}/>
        </Col>
        <Col md={8}>
          <h3 className="section-heading text-uppercase">SHAHEENA NAZIR JUDGE</h3>
          <h3 className="section-subheading text-muted mb-3">Founder & Leadership Coach</h3>
          <p>
          Shaheena Nazir adalah seorang profesional terkemuka dengan lebih dari 25 tahun pengalaman dalam pengembangan SDM, khususnya di bidang strategi pembelajaran transformasional. Ia telah berhasil mendukung lebih dari 100 klien di Asia Tenggara, termasuk dalam berbagai industri terkemuka seperti perbankan dan Finance, FMCG, energi, ritel, otomotif, perkebunan, dan kesehatan. Lulusan Curtin University of Technology, Western Australia, Shaheena telah menerima penghargaan bergengsi seperti Asian Outstanding Achievement Award di Thailand dan Penghargaan dari KADIN Indonesia. Sebagai penulis produktif, ia telah menerbitkan dua buku berpengaruh melalui Gramedia, mengukuhkan kepemimpinan pemikirannya. Dengan keahlian global, Shaheena telah bekerja di Dwellworks Training and Consultant (USA) serta sebagai konsultan di Singapura dan Australia. Melalui pekerjaannya, ia menginspirasi individu dan organisasi untuk membuka potensi mereka dan mencapai hasil luar biasa.
          </p>
        </Col>
      </Row>
      <Row>
        <Col xs={6} md={2}>
          <Image src={book1} rounded style={{width : "180px"}}/>
        </Col>
        <Col xs={6} md={2}>
          <Image src={book2} rounded style={{width : "180px"}}/>
        </Col>
        <Col xs={6} md={2}>
          <Image src={arch1} rounded style={{width : "180px"}}/>
        </Col>
        <Col xs={6} md={2}>
          <Image src={arch2} rounded style={{width : "180px"}}/>
        </Col>
        <Col xs={6} md={2}>
          <Image src={arch3} rounded style={{width : "180px"}}/>
        </Col>
        <Col xs={6} md={2}>
          <Image src={arch4} rounded style={{width : "180px"}}/>
        </Col>
      </Row>
    </Container>
  );
};

export default AboutUs;
